import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import translationEN from "./locales/en/translation.json";
import translationPT from "./locales/pt/translation.json";

// Translation resources
const resources = {
  en: {
    translation: translationEN
  },
  pt: {
    translation: translationPT
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: "pt",
    // Don't set lng explicitly - let LanguageDetector handle it
    debug: false,

    // Language detection options
    detection: {
      // Order and from where user language should be detected
      order: ["localStorage", "navigator"],
      // Keys or params to lookup language from
      lookupLocalStorage: "i18nextLng",
      // Cache user language on
      caches: ["localStorage"],
      // Only detect languages that are in the whitelist
      checkWhitelist: true
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Only allow en and pt
    supportedLngs: ["en", "pt"],

    react: {
      useSuspense: false
    }
  });

export default i18n;
